class InventoryLocation extends HTMLElement {
  connectedCallback() {
    this.dataEl = this.querySelector('[data-inventory-location-data]');
    this.textEl = this.querySelector('[data-inventory-location-text]');
    this.bodyEl = this.querySelector('[data-inventory-location-modal-body]');

    this.currentLocationName = this.dataset.currentLocationName || '';
    this.allowedNonPickupNames = (this.dataset.allowedNonPickupLocations || '')
      .split(',')
      .map((name) => name.trim())
      .filter(Boolean);

    const formId = this.dataset.productFormId;
    const form = formId ? document.getElementById(formId) : this.closest('form');
    this.idInput = form ? form.querySelector('[name="id"]') : document.querySelector('[name="id"]');

    const initialVariantId = (this.idInput && this.idInput.value) || this.dataset.defaultVariantId;
    if (initialVariantId) this.render(initialVariantId);

    if (this.idInput) {
      this.onVariantChange = () => this.render(this.idInput.value);
      this.idInput.addEventListener('change', this.onVariantChange);
    }
  }

  disconnectedCallback() {
    if (this.idInput && this.onVariantChange) this.idInput.removeEventListener('change', this.onVariantChange);
  }

  escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  }

  renderAddress(loc) {
    const line2 = [loc.province, loc.city, loc.address1].filter(Boolean).join(' ');
    return [loc.zip, line2, loc.address2, loc.country, loc.phone]
      .filter(Boolean)
      .map((line) => this.escapeHtml(line))
      .join('<br>');
  }

  renderLocationBlock(name, isCurrent, addressData) {
    const badge = isCurrent
      ? '<span class="location-block__badge">' + this.escapeHtml(this.dataset.currentBadge) + '</span>'
      : '';
    const note = isCurrent ? this.dataset.currentNote : this.dataset.otherNote;
    const noteIcon = isCurrent ? '✓ ' : '';
    const addressHtml = addressData
      ? '<div class="location-block__address">' + this.renderAddress(addressData) + '</div>'
      : '';
    return (
      '<div class="location-block">' +
      '<div class="location-block__header">' +
      '<span class="location-block__name">' + this.escapeHtml(name) + '</span>' +
      badge +
      '</div>' +
      '<div class="location-block__note">' + noteIcon + this.escapeHtml(note) + '</div>' +
      addressHtml +
      '</div>'
    );
  }

  render(variantId) {
    if (!this.dataEl || !this.textEl || !this.bodyEl) return;

    let allData;
    try {
      allData = JSON.parse(this.dataEl.textContent);
    } catch (e) {
      return;
    }

    const variantData = allData[String(variantId)] || { locations: [], trulyOutOfStock: false };

    if (variantData.trulyOutOfStock) {
      this.hidden = true;
      return;
    }

    const locations = variantData.locations || [];
    const currentName = this.currentLocationName;
    // 住所・電話番号は店舗受取有効なロケーションでしか取得できないため、
    // 一致するデータがあれば付与し、なければ名前のみ表示する。
    const current = currentName ? locations.find((loc) => loc.name === currentName) : null;
    const others = locations.filter((loc) => loc.name !== currentName);
    // 店舗一覧モーダルには基本的に店舗受取が有効なロケーションしか表示しない。
    // 例外的に allowedNonPickupNames に含まれる名前だけは、店舗受取が無効でも
    // 名前のみのブロックとして表示を許可する。
    const canShowCurrentInModal = Boolean(currentName) && (current || this.allowedNonPickupNames.includes(currentName));

    if (!currentName && locations.length === 0) {
      this.hidden = true;
      return;
    }
    this.hidden = false;

    const currentDisplayName = current?.displayName || currentName;
    this.textEl.textContent = currentName
      ? this.dataset.summaryLabel + '：' + currentDisplayName
      : this.dataset.summaryLabel + '：' + this.dataset.contactStore;

    let html = '';
    if (canShowCurrentInModal) html += this.renderLocationBlock(currentDisplayName, true, current || null);
    if (others.length > 0) {
      html +=
        '<div class="inventory-location-modal__section-heading">' +
        this.escapeHtml(this.dataset.othersHeading) +
        '</div>';
      others.forEach((loc) => {
        html += this.renderLocationBlock(loc.displayName || loc.name, false, loc);
      });
    }
    this.bodyEl.innerHTML = html;
  }
}

customElements.define('inventory-location', InventoryLocation);
